import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Tag from 'components/forms/Tag';
import { REPLY_STATUS_OPTIONS, REPLY_STATUS_COLORS, REPLY_STATUS_LABEL_LOOKUP } from 'constants/outreach';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import Menu from 'components/Menu/Menu';
import MenuItem from 'components/Menu/MenuItem';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import Tooltip from '@material-ui/core/Tooltip';


const DEFAULT_COLOR = 'primary';

const styles = theme => ({
  chevron: {
    color: theme.palette.white,
    width: '0.875rem',
    height: '0.875rem',
    marginLeft: '0.375rem',
  },
  flashIcon: {
    marginRight: '-0.25rem',
    marginLeft: '0.1875rem',
    color: theme.palette.white,
    width: '0.75rem',
  },
});

const ReplyStatusBadge = ({
  status, className, classes, handleChangeStatus, autoCategorized, ...props
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleNewStatusClick = (newStatus) => {
    handleChangeStatus(newStatus);
    setAnchorEl(null);
  };

  const autoCategorizeIcon = (
    <Tooltip title="Categorized by AI">
      <FlashOnIcon className={classes.flashIcon} />
    </Tooltip>
  );

  return (
    <React.Fragment>
      <Tag
        className={className}
        color={REPLY_STATUS_COLORS[status] ? REPLY_STATUS_COLORS[status] : DEFAULT_COLOR}
        label={<>{REPLY_STATUS_LABEL_LOOKUP[status]}
          {handleChangeStatus ? <ChevronDownIcon className={classes.chevron} /> : null}</>}
        labelPadding={props.labelPadding}
        // This is just a hack to be able to show an icon on the left and on the right at the same time
        icon={autoCategorized ? autoCategorizeIcon : null}
        onClick={e => e.stopPropagation() || setAnchorEl(e.currentTarget)}
        {...props}
      />
      {handleChangeStatus &&
        <Menu
          id="changeStatus-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          {REPLY_STATUS_OPTIONS.map(options =>
            <MenuItem onClick={() => handleNewStatusClick(options)}>{options.label}</MenuItem>)}
        </Menu>
      }
    </React.Fragment>
  );
};

ReplyStatusBadge.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
  handleChangeStatus: PropTypes.func,
  classes: PropTypes.element.isRequired,
  autoCategorized: PropTypes.bool,
};

ReplyStatusBadge.defaultProps = {
  status: null,
  className: null,
  handleChangeStatus: false,
  autoCategorized: false,
};

export default withStyles(styles)(ReplyStatusBadge);
